// Site script. Global pieces (header, theme toggle, cookie banner, reading-list
// modal, footer animation) mount once; page pieces mount into each barba
// container — on first load and after every transition — and are torn down
// again with an AbortController (document/window listeners) and a gsap.context
// (ScrollTriggers, SplitText, inline styles).
import { initHeader } from "./modules/header.js";
import { initTheme } from "./modules/theme.js";
import { initCookie } from "./modules/cookie.js";
import { initReadingBar } from "./modules/reading-bar.js";
import { initShare } from "./modules/share.js";
import { initReadingListModal, initReadingListPage, pageState } from "./modules/reading-list.js";
import { initMap } from "./modules/map.js";
import { initAdvice } from "./modules/advice.js";
import { initQuiz } from "./modules/quiz.js";
import { initSignupDemo } from "./modules/signup-demo.js";
import { initAnimations, initFooterAnimation } from "./animations.js";
import { initTransitions } from "./transitions.js";
import { ScrollTrigger } from "./motion.js";

let page = null;

function mount(container, { delay = 0.1 } = {}) {
  const abort = new AbortController();
  const { signal } = abort;

  initReadingBar({ signal });
  initShare();
  pageState.map = initMap({ signal });
  initReadingListPage();
  initAdvice();
  initQuiz();
  initSignupDemo();
  if (window.wpsInitNewsletter) window.wpsInitNewsletter(container);

  page = { abort, anim: initAnimations(container, { delay }) };
}

function unmount() {
  if (!page) return;
  page.abort.abort();
  if (page.anim) page.anim.revert();
  pageState.map = null;
  page = null;
}

document.addEventListener("DOMContentLoaded", () => {
  initHeader();
  initTheme();
  initCookie();
  initReadingListModal();
  initFooterAnimation();

  const barbaOn = window.wpsData && window.wpsData.barba && document.querySelector('[data-barba="container"]');
  if (barbaOn) {
    initTransitions({ mount, unmount });
  } else {
    mount(document, { delay: 0.1 });
  }
});

// Fonts and lazy images shift layout: re-measure scroll triggers once loaded.
window.addEventListener("load", () => ScrollTrigger.refresh());
